<!-- 三方导入 -->
<template>
  <!-- 移动端 -->
  <el-drawer
    v-if="isMobile()"
    v-model="detailVisible"
    class="third-import-drawer"
    destroy-on-close
    direction="btt"
    header-class="third-import-drawer__header"
    size="77%"
    :title="isMedicalIndustry ? '拜访记录' : '三方导入'"
  >
    <div class="drawer-content">
      <Core
        :device-info="deviceInfo"
        :is-medical-industry="isMedicalIndustry"
        @handleSendRecord="handleSendRecord"
      />
    </div>
  </el-drawer>
  <!-- PC端 -->
  <el-dialog
    v-else
    v-model="detailVisible"
    align-center
    append-to-body
    body-class="third-import-dialog__body"
    class="third-import-dialog"
    destroy-on-close
    header-class="third-import-dialog__header"
    width="375"
  >
    <Core
      :device-info="deviceInfo"
      :is-medical-industry="isMedicalIndustry"
      @handleSendRecord="handleSendRecord"
    />
  </el-dialog>
</template>

<script setup>
import { ref, watch } from 'vue'
import { isMobile } from '@/utils'
import Core from './components/core.vue'

const emits = defineEmits(['update:showDetail', 'handleSendRecord'])
const props = defineProps({
  showDetail: {
    type: Boolean,
    default: false
  },
  // 设备启用信息
  deviceInfo: {
    type: Object,
    default: () => ({})
  },
  // 是否医疗行业
  isMedicalIndustry: {
    type: Number,
    default: 0
  }
})

const detailVisible = ref(props.showDetail)

/**
 * 处理录音发送
 * @param recordInfo 录音信息
 */
const handleSendRecord = (recordInfo) => {
  emits('handleSendRecord', recordInfo)
}

// 监听props变化，同步到本地状态
watch(
  () => props.showDetail,
  (val) => {
    detailVisible.value = val
  }
)
// 监听本地状态变化，通知父组件
watch(
  () => detailVisible.value,
  (val) => {
    emits('update:showDetail', val)
  }
)
</script>

<style lang="scss" scoped>
$text-main: #323233;
$text-family: PingFang SC;

.text-title {
  font-family: $text-family;
  font-size: 14px;
  font-weight: 600;
  color: $text-main;
}
.text-main {
  font-family: $text-family;
  font-size: 14px;
  font-weight: normal;
  color: $text-main;
}
.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 420px;
  font-size: 14px;
  color: #969799;
}
.dialog-header {
  margin: 24px;
}
.drawer-content {
  padding: 0 12px;
}
:deep(.el-dialog__headerbtn) {
  z-index: 9999;
}
</style>

<style lang="scss">
.third-import-drawer {
  border-radius: 20px 20px 0px 0px !important;

  &__header {
    padding: 13px 16px 0;
    margin-bottom: 12px;
    text-align: center;
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: normal;
    line-height: normal;
    text-align: center;
    letter-spacing: 0em;
    color: #323233;
  }
}
.third-import-dialog {
  height: 420px;
  border-radius: 12px;
  box-shadow: 0px 2px 30px 2px rgba(0, 0, 0, 0.1);

  &__header {
    border-bottom: none !important;
    position: relative;
    z-index: 3;
  }

  &__body {
    padding: 6px 12px 0 !important;
    position: relative;
    z-index: 1;
  }
}
</style>
